import { Button, Flex, List } from "@theorgchartdev/storybook";
import ToolbarPopover from "@/appComponents/Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";
import cx from "classnames";

export const MoreFieldsListPopover = ({ fields, numberShown, size }) => {
  const fieldsPopoverTrigger = (
    <Flex>
      <Button modifier={"underline"} size={size}>{`+${fields.length - numberShown} more`}</Button>
    </Flex>
  );
  const allFieldsList = [...fields];
  return (
    <ToolbarPopover
      placement={"top"}
      otherPopoverProps={{ reference: fieldsPopoverTrigger }}
      overlayProps={{ className: cx("oc-dynamic-list-size") }}
    >
      <List
        options={allFieldsList.map(field => {
          return { label: `\u2022 ${field}`, value: field };
        })}
        optionSize={"small"}
      />
    </ToolbarPopover>
  );
};
